import React from 'react'
import PublicPage from '../../../../components/features/GlobalPages/PublicPage'
import Illustration from '../../../../assets/404.svg'
import { PrimaryButton } from '../../../../components/ui/Button'
import {
    PrimaryText,
    SecondaryText,
    Title,
} from '../../../../components/ui/Text'
import { Box, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const LeftSide = () => {
    return (
        <Box sx={{ maxWidth: '80%', margin: 'auto' }}>
            <PrimaryText textAlign="left" mb={8}>
                Des tableaux de bord concrets et dynamiques pour piloter et
                valoriser vos données
            </PrimaryText>
            <img
                src={Illustration}
                alt="Illustration"
                style={{ width: '45vw', height: '50vh' }}
            />
        </Box>
    )
}

export default function PageDistributorNotSet() {
    const alignement = 'left'
    const navigate = useNavigate()

    return (
        <PublicPage staticComponent={<LeftSide />}>
            <Grid container direction="column">
                <Grid item mb={8} textAlign={alignement}>
                    <Grid item>
                        <SecondaryText>
                            Alerte DVNI (Distributeur Volant Non Identifié) !
                        </SecondaryText>
                    </Grid>
                    <Grid item>
                        <Title>
                            Contactez KaryonFood pour l'ajouter à votre espace
                        </Title>
                    </Grid>
                    <Grid item sx={{ marginTop: '1em' }}>
                        <PrimaryButton
                            onClick={() => {
                                navigate('/')
                            }}
                        >
                            Accueil
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </PublicPage>
    )
}
